const COLUMNS = [
  ['Rank', r => r.rank],
  ['Name', r => r.name],
  ['Job title', r => r.role || ''],
  ['Roles', r => (r.roles || []).join('; ')],
  ['Companies', r => (r.companies || []).join('; ')],
  ['Level', r => r.level_name],
  ['Growth score', r => r.growth_score],
  ['KPI', r => r.kpi_score],
  ['Tasks', r => r.task_score],
  ['AI', r => r.ai_score],
  ['Habits', r => r.habit_score],
  ['Trend', r => r.trend],
  ['Praise received', r => r.recognition_received],
  ['Praise given', r => r.recognition_given],
]

// Quote fields with commas/quotes/newlines; neutralise spreadsheet formulas in text cells.
function cell(value) {
  let s = value === null || value === undefined ? '' : String(value)
  if (typeof value === 'string' && /^[=+\-@]/.test(s)) s = "'" + s
  return /[",\r\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s
}

export function buildCsv(rows) {
  const lines = [COLUMNS.map(c => cell(c[0])).join(',')]
  rows.forEach(r => lines.push(COLUMNS.map(c => cell(c[1](r))).join(',')))
  return '﻿' + lines.join('\r\n')
}

export function csvFilename(range) {
  const from = range.from === 'all' ? 'all-time' : range.from
  return `employee-growth_${from}_${range.to}.csv`
}
